module.exports = __webpack_public_path__ + "img/collection-engagementRingsBestseller@2x.598a808.jpg";